<template>

    <div class="w-full">
        <CustomTable class="bg-white rounded shadow-md group" v-if="videos.length !== 0">
            <template v-slot:header>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Thumbnail</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Video Details</th>
                <th class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">Action</th>
            </template>
            <template v-slot:body>
                <tr v-for="video in videos">
                    <td class="py-4 px-6 border-b border-grey-light w-48">
                        <progressive-img fallback="/static/image-unavailable.png" :src="video.thumbnailUrl" />
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light">
                        <strong>{{ video.title }}</strong> <br/>
                        {{ video.created_at | displayLocalDateTime }}<br/>
                        Duration: {{ video.length | timecode }}
                    </td>
                    <td class="py-4 px-6 border-b border-grey-light text-right">
                        <Dropdown class="ml-auto mt-5 lg:mt-0">
                            <template #trigger="{ hasFocus, isOpen }">
                                <div class="px-2 py-1 text-white rounded" :class="[(hasFocus || isOpen) ? 'bg-blue-500' : 'bg-blue-700']">
                                    Actions <i class="fa fa-caret-down ml-1"></i>
                                </div>
                            </template>
                            <template #dropdown>
                                <div class="mt-3 bg-white xl:border rounded-lg w-48 py-2 shadow-xl text-left">
                                    <a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" v-on:click="viewVideo(video)"><i class="fa fa-eye mr-2"></i> View</a>
                                    <a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" v-on:click="editVideo(video)"><i class="fa fa-pencil mr-2"></i> Edit</a>
                                    <a href="#" class="block hover:text-white px-4 py-2 hover:bg-blue-500" v-on:click="downloadVideo(video.id)"><i class="fa fa-download mr-2"></i> Download</a>
                                </div>
                            </template>
                        </Dropdown>
                    </td>
                </tr>
                <tr class="bg-grey-lighter text-center" v-if="polling">
                    <td class="py-5" colspan="4">
                        <h1 class="text-xl"><i class="fa fa-circle-notch fa-spin"></i></h1>
                    </td>
                </tr>
                <infinite-loading @infinite="infiniteHandler" v-if="current_page <= last_page"></infinite-loading>
            </template>
        </CustomTable>
        <view-video-modal></view-video-modal>
        <edit-video-modal></edit-video-modal>
    </div>
			
</template>

<script>

    import { EventBus } from '@/utils/events';
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';

    import CustomTable from '@/components/general/CustomTable'
    import ViewVideoModal from './modals/ViewVideoModal'
    import EditVideoModal from './modals/EditVideoDetails'
    import InfiniteLoading from 'vue-infinite-loading';
    import Dropdown from '@/components/partials/Dropdown'

	export default {
		name: 'HelloWorld',
		data () {
			return {
                options: this.getAuthorizationHeader(),

                videos: [],
                
                resource_url: Config.apiPath + "/api/v2/stringer/videos",
                current_page: 1,
                last_page: null,
                polling: true
			}
        },
        components: {
            'view-video-modal': ViewVideoModal,
            'edit-video-modal': EditVideoModal,
            InfiniteLoading,
            CustomTable,
            Dropdown,
		},
        mounted() {
            this.getVideos();
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getVideos() {
                this.$http.get(Config.apiPath + "/api/v2/stringer/videos", this.getAuthorizationHeader()).then((response) => {
                    this.$set(this, 'videos', response.data.data)
                    this.$set(this, 'last_page', response.data.last_page)
                    this.$set(this, 'polling', false)
                });
            },
            downloadVideo(id) {
                this.$http.get(Config.apiPath + "/api/v2/stringer/videos/" + id + "/download", this.getAuthorizationHeader())
                    .then(response => {
                        var link = document.createElement('a');
                        document.body.appendChild(link);
                        link.href = response.data;
                        link.click();
                        document.body.removeChild(link);
                    }, () => {
                        alert('You do not own this video, therefore you cannot download it.');
                    });
            },
            viewVideo(video) {
                EventBus.$emit('stringer-view-video-open-modal', video);
            },
            editVideo(video) {
                EventBus.$emit('stringer-edit-video-open-modal', video);
            },

            infiniteHandler($state) {

                var _this = this;

                this.$http.get(this.resource_url + "?page=" + (this.current_page), this.getAuthorizationHeader()).then((response) => {

                    _this.current_page = response.data.current_page + 1;

                    var data = response.data.data;

                    const temp = [];
                    for (var i = 0; i < data.length; i++) {
                        temp.push(data[i]);
                    }
                    _this.videos = _this.videos.concat(temp);

                    $state.loaded();

                });

            },
        },
        filters: {
            timecode: function(value) {
                if(value !== null) {
                    var seconds = Math.floor( value % 60 ).toString();
                    var minutes = Math.floor( value / 60 ).toString();
                    if( seconds.length === 1 ){
                        seconds = '0' + seconds;
                    }                
                    return minutes + ':' + seconds;
                }
            },
            displayLocalDateTime: function(date) {
                return moment.utc(date).local().format('MMMM Do YYYY, h:mm a');
            }
        }
	}
</script>

<style scoped>

</style>
